import React from "react";
import { OrqHeader } from "@orquestra-web/react";
import styles from "./index.module.css";

const docsHost = "https://dataservicesdocs.btgpactualsolutions.com";
const mainSiteUrl = "https://dataservices.btgpactual.com/site";

const getDocsTarget = (id?: number) => {
  const hostname = window.location.hostname;
  const localBase = `http://${hostname}`;
  const isLocal = ["localhost", "127.0.0.1", "10.169.158.153"].includes(hostname);
  const targets: Record<number, string> = {
    1: isLocal ? `${localBase}:4100/home` : `${docsHost}/home`,
    2: isLocal ? `${localBase}:4200/restapi` : `${docsHost}/restapi`,
    3: isLocal ? `${localBase}:4201/asyncapi` : `${docsHost}/asyncapi`,
    4: isLocal ? `${localBase}:4102/mcp` : `${docsHost}/mcp/index.html`,
  };

  return id ? targets[id] : undefined;
};

const Header: React.FC = () => {
  const logoBasePath = process.env.REACT_APP_PATH_HOME || "/home/assets";
  const navItems = [
    { text: "Home", id: 1, selected: true, children: [] },
    { text: "Rest API", id: 2, selected: false, children: [] },
    { text: "Websocket", id: 3, selected: false, children: [] },
    { text: "MCP", id: 4, selected: false, children: [] },
  ];

  const handleNavigation = (item: { id?: number }) => {
    const target = getDocsTarget(item.id);

    if (target) {
      window.location.href = target;
    }
  };

  return (
    <header className={`${styles.headerShell} ${styles.activeHome}`}>
      <OrqHeader
        color="neutral"
        logoUrl={`${logoBasePath}/btg-dataservices.svg`}
        logoAlt="BTG Pactual Data Services"
        menuTopbar
        itemsTopBar={navItems}
        showProfile={false}
        modalProfile={false}
        onClickLogo={() => {
          window.location.href = mainSiteUrl;
        }}
        onClickMenuTopBar={handleNavigation}
      />
      <a
        className={styles.logoLink}
        href={mainSiteUrl}
        aria-label="Open BTG Pactual Data Services home"
      />
    </header>
  );
};

export default Header;
